export const formatTime = (time: number) => (time < 10 ? `0${time}` : `${time}`);
export const isTimerFinished = (estimatedStopTime: string | null): boolean => {
    if (!estimatedStopTime) return false;
    return Date.parse(new Date().toISOString()) > Date.parse(estimatedStopTime);
};
export const calcRemainingSeconds = (
    estimatedStopTime: string | null,
    nowISO: string = new Date().toISOString(),
): number => {
    if (!estimatedStopTime) return 0;

    return Math.max(0, Math.ceil((Date.parse(estimatedStopTime) - Date.parse(nowISO)) / 1000));
};
export const clamp = (v: number, max: number) => Math.min(Math.max(v, 0), max);
